/* eslint-disable max-statements */
import moment from 'moment';
import {useEffect} from 'react';
import {noTimeZoneFullISODate} from '../../../../../common/constants/datesFormat';
import {advanceReserveListDivided} from '../../../../constants/advanceReserveListDivided';
import {formValidations} from '../../../../constants/formValidations';

const useStateForm = ({
  data,
  handleChange,
  fetchAdviserList,
  fetchFlInventoryAttachments,
}) => {
  const handleDateChange = (name, value, validation) => {
    const valueModified = moment(value).format(noTimeZoneFullISODate);
    handleChange(name, valueModified, validation);
  };

  const handleFloatingStateChange = (name, value, validation) => {
    if (!name) {
      return;
    }
    handleChange(name, value, validation);
    handleChange('reserveAdvance', '', formValidations.reserveAdvance(data));
    if (value === 'R') {
      handleChange('reserveAdvance', 'SC', formValidations.reserveAdvance(data));
    }
  };

  useEffect(() => {
    fetchAdviserList(data.dealerReservation);
  }, [data.dealerReservation]);

  const handleAdviserSelector = () => {
    fetchAdviserList(data.dealerReservation);
  };

  const handleDealerChange = (name, value, validation) => {
    handleChange(name, value, validation);
    handleChange('adviserCode', '', formValidations.adviserCode(data));
  };

  const handleBusinessTypeChange = (name, value, validation) => {
    handleChange(name, value, validation);
    handleChange('clientType', '', formValidations.documentType(data));
    handleChange('contributorCode', '', formValidations.contributorCode(data));
  };

  const isSolNac = data.floatingState === 'S';

  const mappedReserveAdvance = data.floatingState === 'R' ?
    advanceReserveListDivided.R :
    (data.floatingState === 'S' ? advanceReserveListDivided.S : []);
  
  return {
    'actions': {
      handleAdviserSelector,
      handleBusinessTypeChange,
      handleDateChange,
      handleDealerChange,
      handleFloatingStateChange,
    },
    'dataValues': {
      isSolNac,
      mappedReserveAdvance,
    },
  };
};

export default useStateForm;
